module.exports = __webpack_public_path__ + "static/nur-adfb3d5ba44e4a74c42fa3bc3a556e3c.png";